import { TitlebarComponent } from '../../../shared/titlebar/titlebar.component';
import { EVENTO, TYPEPAGE } from '../../../shared/common/constant.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { officeAplicacionListComponent } from '../officeAplicacion/officeAplicacionList/officeAplicacion.component';

@Component({
  //moduleId: module.id,
  selector: 'app-officeApp',
  templateUrl: 'officeApp.component.html'
})

export class officeaAplicacionComponent implements OnInit {
  @ViewChild(officeAplicacionListComponent) officeAplicacionListComponent: officeAplicacionListComponent;
  @ViewChild(TitlebarComponent) titlebarComponent: TitlebarComponent;

  evento: EVENTO;
  modulo: string;
  mantenimiento: string;
  titleGeneral: string;
  titleInsertar: string;
  titleEditar: string;
  titleConsultar: string;
  msgEditar: string;
  dataOfficeAplicacion: any;
  landingPage: string;

  constructor() {
  }

  ngOnInit() {
    this.landingPage = "/landingAccess";
    this.evento = EVENTO.listar;
    this.modulo = "Seguridad";
    this.mantenimiento = "Aplicaciones Para Oficinas";
    this.titleGeneral = this.modulo + ": " + this.mantenimiento;
    this.msgEditar = "EDITAR " + this.mantenimiento.toUpperCase();

    this.setTitleListar();
  }

  setTitleListar() {
    this.titlebarComponent.iClose = true;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: "" }];
    this.titlebarComponent.eventClose = this.landingPage;
  }

  setTitleInsertar(data: any) {
    this.titleInsertar = "Nuevo Oficina Aplicacion";
    this.titlebarComponent.iCancel = true;
    this.titlebarComponent.eventCancel = EVENTO.listar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleInsertar, event: "" }];
    this.dataOfficeAplicacion = data;
  }

  setTitleEditar(data: any) {
    this.titleEditar = this.mantenimiento + ": " + " (Cod. " + data.ID + ")";
    this.titlebarComponent.iCancel = true;
    this.titlebarComponent.eventCancel = EVENTO.consultar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleEditar, event: "" }];
  }

  setTitleConsultar(data: any) {
    this.titleConsultar = this.mantenimiento + ": " + data.nomDistrito + " (Cod. " + data.codDistrito + ")";
    this.titlebarComponent.iBack = true;
    this.titlebarComponent.iEdit = true;
    this.titlebarComponent.eventBack = EVENTO.listar;
    this.titlebarComponent.eventEdit = EVENTO.editar;
    this.titlebarComponent.msgEditar = this.msgEditar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleConsultar, event: "" }];
  }

  clearTitlebar() {
    this.titlebarComponent.iBack = false;
    this.titlebarComponent.iCancel = false;
    this.titlebarComponent.iClose = false;
    this.titlebarComponent.iEdit = false;
    this.titlebarComponent.msgEditar = "";
    this.titlebarComponent.msgTitle = [];
    this.titlebarComponent.eventBack = EVENTO.listar;
    this.titlebarComponent.eventCancel = EVENTO.listar;
    this.titlebarComponent.eventClose = "";
    this.titlebarComponent.eventEdit = EVENTO.listar;
  }

  changeEvent(evento: any) {
    this.evento = evento.evento;
    this.clearTitlebar();
    this.titlebarComponent.data = evento.data;

    switch (this.evento) {
      case EVENTO.listar:
        this.setTitleListar();
        break;
      case EVENTO.crear:
        this.setTitleInsertar(evento.data);
        break;
      case EVENTO.editar:
        this.setTitleEditar(evento.data);
        break;
      case EVENTO.consultar:
        this.setTitleConsultar(evento.data);
        break;
      default:
        break;
    }
  }
}

